module.exports = __webpack_public_path__ + "img/4.264015f6.jpg";